import CoordiApatmentList from '../coordinator/CoordiApatmentList'

const ZoneHeadStudentList = () => {
    return (
        <CoordiApatmentList />
    )
}

export default ZoneHeadStudentList